const MODULE_NAME = 'fulcrum/container/Role/Project'
const MOUNT = 'fulcrum/container/Role/Project/MOUNT'
const UNMOUNT = 'fulcrum/container/Role/Project/UNMOUNT'

const CLEAR_PROJECT_ID = 'fulcrum/container/Role/Project/CLEAR_PROJECT_ID'
const CLEAR_PROJECT_ROLE = 'fulcrum/container/Role/Project/CLEAR_PROJECT_ROLE'
const CHANGE_PROJECT_ROLE = 'fulcrum/container/Role/Project/CHANGE_PROJECT_ROLE'
const CHANGE_PROJECT_ROLE_START = 'fulcrum/container/Role/Project/CHANGE_PROJECT_ROLE_START'
const CHANGE_PROJECT_ROLE_SUCCESS = 'fulcrum/container/Role/Project/CHANGE_PROJECT_ROLE_SUCCESS'
const UPDATE_PROJECT_ROLE = 'fulcrum/container/Role/Project/UPDATE_PROJECT_ROLE'
const UPDATE_PROJECT_ID = 'fulcrum/container/Role/Project/UPDATE_PROJECT_ID'

const FETCH_PROJECT_PERMISSION = 'fulcrum/container/Role/Project/FETCH_PROJECT_PERMISSION'
const FETCH_PROJECT_PERMISSION_START = 'fulcrum/container/Role/Project/FETCH_PROJECT_PERMISSION_START'
const FETCH_PROJECT_PERMISSION_SUCCESS = 'fulcrum/container/Role/Project/FETCH_PROJECT_PERMISSION_SUCCESS'
const FETCH_PROJECT_PERMISSION_ERROR = 'fulcrum/container/Role/Project/FETCH_PROJECT_PERMISSION_ERROR'

const UPDATE_ROLE_STATUS = 'fulcrum/container/Role/Project/UPDATE_ROLE_STATUS'

export {
  MODULE_NAME,
  MOUNT,
  UNMOUNT,
  CLEAR_PROJECT_ROLE,
  CLEAR_PROJECT_ID,
  CHANGE_PROJECT_ROLE,
  CHANGE_PROJECT_ROLE_START,
  CHANGE_PROJECT_ROLE_SUCCESS,
  UPDATE_PROJECT_ROLE,
  UPDATE_ROLE_STATUS,
  UPDATE_PROJECT_ID,
  FETCH_PROJECT_PERMISSION,
  FETCH_PROJECT_PERMISSION_START,
  FETCH_PROJECT_PERMISSION_SUCCESS,
  FETCH_PROJECT_PERMISSION_ERROR,
}
